const DEFAULT_NAP_LOCAL = 'http://localhost:8081';
const DEFAULT_API_LOCAL = 'http://localhost:8080';

function inferFromHostname(hostname: string): { baseUrl: string; apiEndpoint: string } {
  return {
    baseUrl: hostname.includes('dev') ? 'https://devnap.joyplay.vn' : 'https://nap.joyplay.vn',
    apiEndpoint: hostname.includes('localhost')
      ? DEFAULT_API_LOCAL
      : hostname.includes('dev')
        ? 'https://devsdkapi.joyplay.vn'
        : 'https://sdkapi.joygames.vn',
  };
}

/**
 * Ưu tiên REACT_APP_NAP_URL / REACT_APP_API_URL (set một hoặc cả hai).
 * REACT_APP_BASE_URL_H5 (tuỳ chọn): shorthand `localhost` hoặc URL đầy đủ cho nap khi chưa set NAP_URL.
 * Không set gì → suy từ window.location.hostname.
 */
export function resolveSdkUrls(): { baseUrl: string; apiEndpoint: string } {
  const napUrl = process.env.REACT_APP_NAP_URL?.trim();
  const apiUrl = process.env.REACT_APP_API_URL?.trim();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const inferred = inferFromHostname(hostname);

  if (napUrl || apiUrl) {
    return {
      baseUrl: napUrl || inferred.baseUrl,
      apiEndpoint: apiUrl || inferred.apiEndpoint,
    };
  }

  const profile = process.env.REACT_APP_BASE_URL_H5?.trim();

  if (profile?.toLowerCase() === 'localhost') {
    return {
      baseUrl: DEFAULT_NAP_LOCAL,
      apiEndpoint: DEFAULT_API_LOCAL,
    };
  }

  if (profile?.startsWith('http://') || profile?.startsWith('https://')) {
    return {
      baseUrl: profile.replace(/\/$/, ''),
      apiEndpoint: inferred.apiEndpoint,
    };
  }

  return inferred;
}

/**
 * URL asset static của SDK (thư mục public/).
 * Dev: path tuyệt đối trên origin hiện tại.
 * Production: cùng host với latest.js / latest.css (REACT_APP_SDK_BASE_URL).
 */
export function resolveSdkAsset(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (process.env.NODE_ENV !== 'production') {
    return normalized;
  }
  const sdkBase = (process.env.REACT_APP_SDK_BASE_URL || 'https://nap.joyplay.vn/sdk').replace(/\/$/, '');
  return `${sdkBase}${normalized}`;
}
